const NewIcon = (props: any) => (
    <svg
        width={58}
        height={28}
        viewBox="0 0 58 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="New"
        {...props}
    >
        <path
            d="M0.545455 14C0.545455 6.56926 6.56926 0.545455 14 0.545455H43.7273C51.158 0.545455 57.1818 6.56926 57.1818 14C57.1818 21.4307 51.158 27.4545 43.7273 27.4545H14C6.56926 27.4545 0.545455 21.4307 0.545455 14Z"
            fill="#F5FBFF"
        />
        <path
            d="M0.545455 14C0.545455 6.56926 6.56926 0.545455 14 0.545455H43.7273C51.158 0.545455 57.1818 6.56926 57.1818 14C57.1818 21.4307 51.158 27.4545 43.7273 27.4545H14C6.56926 27.4545 0.545455 21.4307 0.545455 14Z"
            stroke="#E0F2FE"
            strokeWidth={1.09091}
        />
        <circle cx={10.3635} cy={14} r={3.27273} fill="#0BA5EC" />
        <path
            d="M21.9125 19H20.2805V7.608L28.0245 15.72V8.328H29.6565V19.656L21.9125 11.544V19ZM36.65 16.728L37.962 17.464C37.6633 17.9973 37.2847 18.408 36.826 18.696C36.3033 19.0373 35.642 19.208 34.842 19.208C33.9033 19.208 33.146 18.92 32.57 18.344C31.9087 17.6827 31.578 16.824 31.578 15.768C31.578 14.6587 31.9353 13.736 32.65 13C33.258 12.392 34.01 12.088 34.906 12.088C35.7807 12.088 36.5007 12.3813 37.066 12.968C37.6953 13.6187 38.01 14.568 38.01 15.816V16.008H33.178C33.2207 16.5733 33.4127 17.0267 33.754 17.368C34.042 17.656 34.442 17.8 34.954 17.8C35.37 17.8 35.7273 17.688 36.026 17.464C36.2713 17.272 36.4793 17.0267 36.65 16.728ZM33.29 14.728H36.41C36.346 14.3547 36.186 14.0507 35.93 13.816C35.6527 13.56 35.3007 13.432 34.874 13.432C34.426 13.432 34.058 13.576 33.77 13.864C33.5353 14.0773 33.3753 14.3653 33.29 14.728ZM38.5809 12.264H40.3409L42.0849 16.12L43.9729 11.688L45.8609 16.12L47.6049 12.264H49.3649L45.8609 19.48L43.9729 15.176L42.0849 19.48L38.5809 12.264Z"
            fill="#026AA2"
        />
    </svg>
);

export default NewIcon;
